import React from 'react';

import styles from './Typography.module.css';
import { TypographyProps, TypographyVariant } from './Typography.types';

export const Typography: React.FC<TypographyProps> = ({
  variant = 'body1',
  children,
  className = '',
  id,
  style,
}) => {
  const ComponentMap: Record<TypographyVariant, React.ElementType> = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    subtitle1: 'h4',
    body1: 'p',
    body2: 'p',
    caption: 'span',
  };

  const Component = ComponentMap[variant];
  const classNames = `${styles.typography} ${styles[variant]} ${className}`.trim();

  return (
    <Component id={id} className={classNames} style={style}>
      {children}
    </Component>
  );
};
